import {
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import { useState } from "react";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import styled from "@emotion/styled";

// import TextField from "@mui/material";

export default function PasswTextField({
  value,
  id,
  name,
  category,
  onChange,
  disabled,
  menuItems,
  label,
  error,
  helperText,
  placeholder,
}) {
  //   const {
  // value,
  // id,
  // name,
  // category,
  // onChange,
  // disabled,
  // menuItems,
  // label,
  // error,
  // helperText,
  // placeholder,
  //   } = props;
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleMouseUpPassword = (event) => {
    event.preventDefault();
  };

  return (
    <>
      <FormControl fullWidth disabled={disabled} margin="none" error={error}>
        <InputLabel id={id} sx={{ lineHeight: "15px" }}>
          {label}
        </InputLabel>
        <OutlinedInput
          size="small"
          label={label}
          disabled={disabled}
          id={id}
          labelId={id}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          type={showPassword ? "text" : "password"}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                disabled={disabled}
                aria-label={
                  showPassword ? "hide the password" : "display the password"
                }
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
                onMouseUp={handleMouseUpPassword}
                edge="end">
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          }
        />
        {/* {helperText && <FormHelperText>{helperText}</FormHelperText>} */}
      </FormControl>
    </>
  );
}
